import { render } from "./Product_Detail.vue?vue&type=template&id=c737b414&scoped=true"
import script from "./Product_Detail.vue?vue&type=script&lang=js"
export * from "./Product_Detail.vue?vue&type=script&lang=js"

import "./Product_Detail.vue?vue&type=style&index=0&id=c737b414&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Desktop/SILA/Web/phone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c737b414"]])

export default __exports__